// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMyBookingContactResponse

export type WidgetMyBookingContactApiResponse = {
	phone: string | null;
	email: string | null;
};

export type WidgetMyBookingContact = {
	phone: string | null;
	email: string | null;
};

export function hydrateWidgetMyBookingContact(data: WidgetMyBookingContactApiResponse): WidgetMyBookingContact {
	return { ...data };
}